import { QueryResult, useQuery } from '@apollo/client'
import { ACTIVITY_LIST_INITIAL_DATA } from '../Queries'
import { GetActivityListInitialDataQuery, GetActivityListInitialDataQueryVariables } from '../../../types'

export const useActivityListInitialData = (
  employeeId: string,
  lastYear = false,
): QueryResult<GetActivityListInitialDataQuery, GetActivityListInitialDataQueryVariables> => {
  return useQuery<GetActivityListInitialDataQuery, GetActivityListInitialDataQueryVariables>(ACTIVITY_LIST_INITIAL_DATA, {
    variables: { employeeId, lastYear },
    fetchPolicy: 'network-only',
  })
}
